import React, { Component } from 'react'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import CurrencyInput from './CreateInputs';

export class Prueba extends Component {

    EnvioToken = async (token, idServicio, IdPort, matricula = null, correo = null) => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        if(matricula){
            var raw = JSON.stringify({
                "token": token,
                "idPortal": IdPort,
                "idServicio": idServicio,
                "matricula": matricula,
                'correo': correo
            });
        }else{
            var raw = JSON.stringify({
                "token": token,
                "idPortal": IdPort,
                "idServicio": idServicio
            });
        }

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        await fetch("https://misaldo.tecmilenio.mx/api/Saldos/recepcionToken", requestOptions)
            .then(response => response.json())
            .then(result => {

                let fecha = new Date();
                let dia = fecha.getDate();
                let mes = fecha.getMonth() + 1;
                let year = fecha.getFullYear();
                let hora = fecha.getHours();
                let minutos = fecha.getMinutes();
                let segundos = fecha.getSeconds();

                var fechaMostrar = "";
                if (dia < 10) {
                    fechaMostrar = fechaMostrar + "0" + dia + "/"
                } else {
                    fechaMostrar = fechaMostrar + dia + "/"
                }
                if (mes < 10) {
                    fechaMostrar = fechaMostrar + "0" + mes + "/" + year + " "
                } else {
                    fechaMostrar = fechaMostrar + mes + "/" + year + " "
                }
                if (hora < 10) {
                    fechaMostrar = fechaMostrar + "0" + hora + ":"
                } else {
                    fechaMostrar = fechaMostrar + hora + ":"
                } if (minutos < 10) {
                    fechaMostrar = fechaMostrar + "0" + minutos + ":"
                } else {
                    fechaMostrar = fechaMostrar + minutos + ":"
                } if (segundos < 10) {
                    fechaMostrar = fechaMostrar + "0" + segundos
                } else {
                    fechaMostrar = fechaMostrar + segundos
                }

                this.setState({
                    saldoVencer: result.saldoVencer,
                    cantidadPagar: result.cantidadPagar,
                    saldoMes: result.saldoMes,
                    interesMoratorio: result.interesMoratorio,
                    periodo: result.periodo,
                    fechaCorte: result.fechaCorte,
                    fechaLimitePago: result.fechaLimitePago,
                    saldoTotal: result.saldoTotal,
                    saldoTotalPE: result.saldoTotalPE,
                    saldoAnterior: result.saldoAnterior,
                    matricula: result.matricula,
                    nombre: result.nombreCompleto,
                    email: result.correoAlumno,
                    campus: result.campusAlumno,
                    term: result.term,
                    urlConsulta: result.urlConsulta,
                    botonBloqueoDomiciliar: false,
                    botonBloqueoPago: false,
                    botonSpinner: "",
                    radioDis: false,
                    fechaConsulta: fechaMostrar,
                    botonBloqueoPagoPE: false,
                    botonBloqueoDomiciliarPE: false,
                    botonSpinnerPE: "",
                    checkRadioPE: "pagoCompletoPE",
                    saldoFavorPE: result.saldoFavorPE,
                    saldoFavor: result.saldoFavor

                })
                localStorage.setItem('matricula',result.matricula);
                localStorage.setItem('correo', result.correoAlumno);
                localStorage.setItem('idPort', IdPort);
                console.log(`idportal que llego: ${IdPort} `)
                setTimeout(() => {
                    let valor = parseFloat(this.state.saldoAnterior);
                    let valorPe = parseFloat(this.state.cantidadPagar)

                    if (valor > 0) {
                        this.setState({ botonBloqueoPago: false })
                    } else {
                        this.setState({ botonBloqueoPago: true })
                    }
                    if (valorPe > 0) {
                        this.setState({ botonBloqueoPagoPE: false })
                    } else {
                        this.setState({ botonBloqueoPagoPE: true })
                    }
                }, 250);
                if (result.tieneCredito == false) {
                    document.getElementById("controlled-tab-example-tab-2").parentNode.removeChild(document.getElementById("controlled-tab-example-tab-2"))
                }



            })
            .catch(error => console.log('error', error));

    }

    constructor(props) {
        super(props);
        this.handleSelect = this.handleSelect.bind(this);
        const query = new URLSearchParams(window.location.search);
        let urlParam = query.get("token");
        let urlParamIdServ = query.get("idServicio");
        let urlParamIdPort = query.get("idPortal");
        console.log(`idportal : ${urlParamIdPort} `)
        let matricula;
        let correo;
        if(urlParamIdPort == process.env.REACT_APP_IDCAMPUSDIGITAL || !urlParam){
            matricula = localStorage.getItem('matricula');
            correo = localStorage.getItem('correo');

        }
        if(!urlParamIdPort){
            urlParamIdPort = localStorage.getItem('idPort');
            console.log(`idportal sobreescrito: ${urlParamIdPort} `)
        }


        this.state = {
            fechaConsulta: "",
            key: 1,
            saldoTotal: "",
            saldoTotalPE: "",
            fechaCorte: "",
            fechaLimitePago: "",
            saldoVencer: "",
            cantidadPagar: "",
            radioDis: true,
            saldoFavor: "Saldo total",
            saldoFavorPE: "Saldo total",
            periodo: "",
            saldoAnterior: "",
            matricula: "",
            nombre: "",
            campus: "",
            montoInicial: "",
            cantidad: "",
            codigoTienda: "",
            cvetienda: "",
            llaveTienda: "",
            folioTienda: "",
            tipoMoneda: "",
            servicio: "",
            tipoTransaccion: "",
            descServicio: "",
            idioma: "",
            email: "",
            urlRegreso: "",
            urlAviso: "",
            opcional: "",
            q: "",
            term: "",
            termEncrp: "",
            matriculaEncrp: "",
            campusEncrp: "",
            emailEncrp: "",
            nombreEncr: "",
            botonBloqueoPago: true,
            botonBloqueoDomiciliar: true,
            botonSpinner: "spinner-border spinner-border-sm",
            checkRadio: "pagoCompleto",

            botonBloqueoPagoPE: true,
            botonBloqueoDomiciliarPE: true,
            botonSpinnerPE: "spinner-border spinner-border-sm",
            checkRadioPE: "pagoCompletoPE",
            urlParamIdPort: urlParamIdPort

        }
        this.setState({urlParamIdPort: urlParamIdPort});
        this.EnvioToken(urlParam, urlParamIdServ, urlParamIdPort, matricula, correo);

        console.log(process.env.REACT_APP_IDMIPORTAL);
        console.log(process.env.REACT_APP_IDCAMPUSDIGITAL);
        console.log(urlParamIdPort);
    }

    handleSelect(key) {

        this.setState({ key });
    }

    CambioRadio = (event) => {


        this.setState({ checkRadio: event.target.value });

        var cantidad = parseFloat(this.state.saldoAnterior)


        if (event.target.value == "pagoCompleto") {


            if (cantidad > 0) {
                this.setState({ botonBloqueoPago: false })
            } else {
                this.setState({ botonBloqueoPago: true })
            }

        }
        else {


            if (document.getElementById("inpSaldoParcial").value.replace("$","").replaceAll(",","") > 0) {
                this.setState({ botonBloqueoPago: false })
            } else {
                this.setState({ botonBloqueoPago: true })
            }

        }


    }
    CambioRadioPE = (event) => {

        this.setState({ checkRadioPE: event.target.value });
        var cantidad = parseFloat(this.state.saldoTotalPE)
        if (event.target.value === "pagoCompletoPE") {
            if (cantidad > 0) {
                this.setState({ botonBloqueoPagoPE: false })
            } else {
                this.setState({ botonBloqueoPagoPE: true })
            }
        } else {
            if (document.getElementById("inpSaldoParcialPE").value.replace("$","").replaceAll(",","") > 0) {
                this.setState({ botonBloqueoPagoPE: false })
            } else {
                this.setState({ botonBloqueoPagoPE: true })
            }
        }
    }

    ChangeCantidad = (event) => {

        if (this.state.checkRadio === "pagoParcial" && event.target.value.replace("$","").replaceAll(",","") > 0) {
            this.setState({ botonBloqueoPago: false })
        } else {
            this.setState({ botonBloqueoPago: true })
        }

    }

    ChangeCantidadPE = (event) => {


        if (this.state.checkRadioPE === "pagoParcialPE" && event.target.value.replace("$","").replaceAll(",","") > 0) {
            this.setState({ botonBloqueoPagoPE: false })
        } else {
            this.setState({ botonBloqueoPagoPE: true })
        }
    }
    EnvioCheckOut = (event) => {
        if (event.target.id == "btnCho" && document.getElementById("PagoParcial").checked == true && document.getElementById("inpSaldoParcial").value.replace("$","").replaceAll(",","") <= 0) {
            this.setState({
                colorCero: "background-color: #FFD700"
            })

        } else {
            this.setState({
                botonBloqueoPago: true,
                botonBloqueoDomiciliar: true,
                botonSpinner: "spinner-border spinner-border-sm",
                colorCero: ""
            })
            var myHeaders = new Headers();
            var raw = ""

            myHeaders.append("Content-Type", "application/json");
            if (document.getElementById("PagoParcial").checked == true) {

                raw = JSON.stringify({
                    "matricula": this.state.matricula,
                    "Nombre": this.state.nombre,
                    "Email": this.state.email,
                    "Campus": this.state.campus,
                    "Cantidad": document.getElementById("inpSaldoParcial").value.replace("$","").replaceAll(",",""),
                    //"Term": this.state.term,
                    "Term": '202440',
                    "Total": false,
                    "PrestamoED": false,
                    "Domiciliar": false,
                    "idPortal" : this.state.urlParamIdPort
                });
            } else if (document.getElementById("PagoCompleto").checked == true) {

                raw = JSON.stringify({
                    "matricula": this.state.matricula,
                    "Nombre": this.state.nombre,
                    "Email": this.state.email,
                    "Campus": this.state.campus,
                    "Cantidad": "0",
                    //"Term": this.state.term,
                    "Term": '202440',
                    "Total": true,
                    "PrestamoED": false,
                    "Domiciliar": false,
                    "idPortal" : this.state.urlParamIdPort
                });
            }

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            fetch("https://misaldo.tecmilenio.mx/api/Saldos/Checkout", requestOptions)
                .then(response => response.json())
                .then(result => {

                    this.setState({
                        matriculaEncrp: result.matricula,
                        emailEncrp: result.email,
                        campusEncrp: result.campus,
                        nombreEncr: result.nombre,
                        montoInicial: result.montoInicial,
                        cantidad: result.cantidad,
                        codigoTienda: result.codigoTienda,
                        cvetienda: result.cveTienda,
                        llaveTienda: result.llaveTienda,
                        folioTienda: result.folioTienda,
                        tipoMoneda: result.tipoMoneda,
                        servicio: result.servicio,
                        tipoTransaccion: result.tipoTransaccion,
                        descServicio: result.descServicio,
                        idioma: result.idioma,
                        urlRegreso: result.urlRegreso,
                        urlAviso: result.urlAviso,
                        opcional: result.opcional,
                        q: result.q,
                        termEncrp: result.term,
                        botonBloqueoPago: false,
                        botonBloqueoDomiciliar: false,
                        botonSpinner: ""


                    })
                    if (event.target.id == "btnCho") {
                        setTimeout(() => { document.getElementById("FormCheckOut").submit() }, 250);
                    } else if (event.target.id == "btnDmi") {
                        setTimeout(() => { document.getElementById("FormDom").submit() }, 250);
                    }




                })
                .catch(error => console.log('error', error));
        }
    }
    EnvioCheckOutPE = (event) => {
        if (event.target.id == "btnCho" && document.getElementById("PagoParcialPE").checked == true && document.getElementById("inpSaldoParcialPE").value.replace("$","").replaceAll(",","") <= 0) {
            this.setState({
                colorCero: "background-color: #FFD700"
            })

        } else {
            this.setState({
                botonBloqueoPagoPE: true,
                botonBloqueoDomiciliarPE: true,
                botonSpinnerPE: "spinner-border spinner-border-sm",
                colorCero: ""
            })
            var myHeaders = new Headers();
            var raw = ""

            myHeaders.append("Content-Type", "application/json");
            if (document.getElementById("PagoParcialPE").checked == true) {

                raw = JSON.stringify({
                    "matricula": this.state.matricula,
                    "Nombre": this.state.nombre,
                    "Email": this.state.email,
                    "Campus": this.state.campus,
                    "Cantidad": document.getElementById("inpSaldoParcialPE").value.replace("$","").replaceAll(",",""),
                    //"Term": this.state.term,
                    "Term": '202440',
                    "Total": false,
                    "PrestamoED": true,
                    "Domiciliar": false,
                    "idPortal" : this.state.urlParamIdPort
                });
            } else if (document.getElementById("PagoCompletoPE").checked == true) {

                raw = JSON.stringify({
                    "matricula": this.state.matricula,
                    "Nombre": this.state.nombre,
                    "Email": this.state.email,
                    "Campus": this.state.campus,
                    "Cantidad": "0",
                    //"Term": this.state.term,
                    "Term": '202440',
                    "Total": true,
                    "PrestamoED": true,
                    "Domiciliar": false,
                    "idPortal" : this.state.urlParamIdPort
                });
            }

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            fetch("https://misaldo.tecmilenio.mx/api/Saldos/CheckoutPE", requestOptions)
                .then(response => response.json())
                .then(result => {

                    this.setState({
                        matriculaEncrp: result.matricula,
                        emailEncrp: result.email,
                        campusEncrp: result.campus,
                        nombreEncr: result.nombre,
                        montoInicial: result.montoInicial,
                        cantidad: result.cantidad,
                        codigoTienda: result.codigoTienda,
                        cvetienda: result.cveTienda,
                        llaveTienda: result.llaveTienda,
                        folioTienda: result.folioTienda,
                        tipoMoneda: result.tipoMoneda,
                        servicio: result.servicio,
                        tipoTransaccion: result.tipoTransaccion,
                        descServicio: result.descServicio,
                        idioma: result.idioma,
                        urlRegreso: result.urlRegreso,
                        urlAviso: result.urlAviso,
                        opcional: result.opcional,
                        q: result.q,
                        termEncrp: result.term,
                        botonBloqueoPagoPE: false,
                        botonBloqueoDomiciliarPE: false,
                        botonSpinnerPE: ""


                    })
                    if (event.target.id == "btnCho") {
                        setTimeout(() => { document.getElementById("FormCheckOut").submit() }, 250);
                    } else if (event.target.id == "btnDmi") {
                        setTimeout(() => { document.getElementById("FormDom").submit() }, 250);
                    }




                })
                .catch(error => console.log('error', error));
        }
    }
    Domiciliar = (event) => {
        if (event.target.id == "btnCho" && document.getElementById("PagoParcial").checked == true && document.getElementById("inpSaldoParcial").value.replace("$","").replaceAll(",","") <= 0) {
            this.setState({
                colorCero: "background-color: #FFD700"
            })

        } else {
            this.setState({
                botonBloqueoPago: true,
                botonBloqueoDomiciliar: true,
                botonSpinner: "spinner-border spinner-border-sm",
                colorCero: ""
            })
            var myHeaders = new Headers();
            var raw = ""

            myHeaders.append("Content-Type", "application/json");
            if (document.getElementById("PagoParcial").checked == true) {

                raw = JSON.stringify({
                    "matricula": this.state.matricula,
                    "Nombre": this.state.nombre,
                    "Email": this.state.email,
                    "Campus": this.state.campus,
                    "Cantidad": document.getElementById("inpSaldoParcial").value.replace("$","").replaceAll(",",""),
                    //"Term": this.state.term,
                    "Term": '202440',
                    "Total": false,
                    "PrestamoED": false,
                    "Domiciliar": true
                });
            } else if (document.getElementById("PagoCompleto").checked == true) {

                raw = JSON.stringify({
                    "matricula": this.state.matricula,
                    "Nombre": this.state.nombre,
                    "Email": this.state.email,
                    "Campus": this.state.campus,
                    "Cantidad": "0",
                    //"Term": this.state.term,
                    "Term": '202440',
                    "Total": true,
                    "PrestamoED": false,
                    "Domiciliar": true
                });
            }

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            fetch("https://misaldo.tecmilenio.mx/api/Saldos/Checkout", requestOptions)
                .then(response => response.json())
                .then(result => {

                    this.setState({
                        matriculaEncrp: result.matricula,
                        emailEncrp: result.email,
                        campusEncrp: result.campus,
                        nombreEncr: result.nombre,
                        montoInicial: result.montoInicial,
                        cantidad: result.cantidad,
                        codigoTienda: result.codigoTienda,
                        cvetienda: result.cveTienda,
                        llaveTienda: result.llaveTienda,
                        folioTienda: result.folioTienda,
                        tipoMoneda: result.tipoMoneda,
                        servicio: result.servicio,
                        tipoTransaccion: result.tipoTransaccion,
                        descServicio: result.descServicio,
                        idioma: result.idioma,
                        urlRegreso: result.urlRegreso,
                        urlAviso: result.urlAviso,
                        opcional: result.opcional,
                        q: result.q,
                        termEncrp: result.term,
                        botonBloqueoPago: false,
                        botonBloqueoDomiciliar: false,
                        botonSpinner: ""


                    })
                    if (event.target.id == "btnCho") {
                        setTimeout(() => { document.getElementById("FormCheckOut").submit() }, 250);
                    } else if (event.target.id == "btnDmi") {
                        setTimeout(() => { document.getElementById("FormDom").submit() }, 250);
                    }




                })
                .catch(error => console.log('error', error));
        }
    }
    DomiciliarPE = (event) => {
        if (event.target.id == "btnCho" && document.getElementById("PagoParcialPE").checked == true && document.getElementById("inpSaldoParcialPE").value.replace("$","").replaceAll(",","") <= 0) {
            this.setState({
                colorCero: "background-color: #FFD700"
            })

        } else {
            this.setState({
                botonBloqueoPagoPE: true,
                botonBloqueoDomiciliarPE: true,
                botonSpinnerPE: "spinner-border spinner-border-sm",
                colorCero: ""
            })
            var myHeaders = new Headers();
            var raw = ""

            myHeaders.append("Content-Type", "application/json");
            if (document.getElementById("PagoParcialPE").checked == true) {

                raw = JSON.stringify({
                    "matricula": this.state.matricula,
                    "Nombre": this.state.nombre,
                    "Email": this.state.email,
                    "Campus": this.state.campus,
                    "Cantidad": document.getElementById("inpSaldoParcialPE").value.replace("$","").replaceAll(",",""),
                    //"Term": this.state.term,
                    "Term": '202440',
                    "Total": false,
                    "PrestamoED": true,
                    "Domiciliar": true
                });
            } else if (document.getElementById("PagoCompletoPE").checked == true) {

                raw = JSON.stringify({
                    "matricula": this.state.matricula,
                    "Nombre": this.state.nombre,
                    "Email": this.state.email,
                    "Campus": this.state.campus,
                    "Cantidad": "0",
                    //"Term": this.state.term,
                    "Term": '202440',
                    "Total": true,
                    "PrestamoED": true,
                    "Domiciliar": true
                });
            }

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            fetch("https://misaldo.tecmilenio.mx/api/Saldos/CheckoutPE", requestOptions)
                .then(response => response.json())
                .then(result => {

                    this.setState({
                        matriculaEncrp: result.matricula,
                        emailEncrp: result.email,
                        campusEncrp: result.campus,
                        nombreEncr: result.nombre,
                        montoInicial: result.montoInicial,
                        cantidad: result.cantidad,
                        codigoTienda: result.codigoTienda,
                        cvetienda: result.cveTienda,
                        llaveTienda: result.llaveTienda,
                        folioTienda: result.folioTienda,
                        tipoMoneda: result.tipoMoneda,
                        servicio: result.servicio,
                        tipoTransaccion: result.tipoTransaccion,
                        descServicio: result.descServicio,
                        idioma: result.idioma,
                        urlRegreso: result.urlRegreso,
                        urlAviso: result.urlAviso,
                        opcional: result.opcional,
                        q: result.q,
                        termEncrp: result.term,
                        botonBloqueoPagoPE: false,
                        botonBloqueoDomiciliarPE: false,
                        botonSpinnerPE: ""


                    })
                    if (event.target.id == "btnCho") {
                        setTimeout(() => { document.getElementById("FormCheckOut").submit() }, 250);
                    } else if (event.target.id == "btnDmi") {
                        setTimeout(() => { document.getElementById("FormDom").submit() }, 250);
                    }




                })
                .catch(error => console.log('error', error));
        }
    }


    render() {
        return (
            <div>
                <div className="container mt-5">
                    <div className="card">
                        <div className="card-header headerCard rounded-top">
                            <div className="row">
                                <div className="headerMiSaldo col-10">
                                    <h2 className="titleHeader">Mi Saldo</h2>
                                    <h6 className="titleHeader">Resumen de mi Estado de Cuenta</h6>
                                </div>
                                <div className="iconHeader col">
                                    <i className="bi bi-three-dots-vertical iconDots"></i>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <Tabs activeKey={this.state.key} onSelect={this.handleSelect} id="controlled-tab-example">
                                <Tab eventKey={1} className="nav-item" title="TecMilenio">
                                    <div className="billSection">
                                        <div className="billRow row billRowMain">
                                            <div className="col-6 ">
                                                <p>{this.state.saldoFavor}</p>
                                            </div>
                                            <div className="col-6 payInfo">
                                                <h6>${this.state.saldoTotal}</h6>
                                            </div>
                                        </div>
                                        <div className="billRow">
                                            <div className="billRow row">
                                                <div className="col-6">
                                                    <h6 className="infoDisplay">Saldo a pagar</h6>
                                                    <span id="interest">para no generar intereses</span>
                                                </div>
                                                <div className="col-6 payInfo">
                                                    <h6>${this.state.saldoAnterior}</h6>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="billRow">
                                            <div className="billRow row mt-3">
                                                <div className="col-6">
                                                    <p className="infoDisplay mb-2">Fecha de corte</p>
                                                    <p>Fecha límite de pago</p>
                                                </div>
                                                <div className="col-6 payDate">
                                                    <h6>{this.state.fechaCorte}</h6>
                                                    <h6>{this.state.fechaLimitePago}</h6>
                                                </div>
                                            </div>
                                        </div>
                                        {this.state.urlParamIdPort == process.env.REACT_APP_IDMIPORTAL &&
                                            <div className="billRow">
                                                <div className="billRow row">
                                                    <div className="accountState">
                                                        <a className="link-success" target="_blank" rel="noreferrer noopener" href={this.state.urlConsulta}>Ver estado de cuenta</a>
                                                        <i className="bi bi-arrow-right"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div className="paySection">
                                        <div>
                                            <div>
                                                <p>Pagar</p>
                                            </div>
                                        </div>
                                        <div className="amountSection row">
                                            <div className="amountCheckBox col-6">
                                                <input type="radio" disabled={this.state.radioDis} name="pago" id="PagoCompleto" value="pagoCompleto" onChange={this.CambioRadio} checked={this.state.checkRadio === "pagoCompleto"} aria-label="Radio button for following text input" className="mt-1" />
                                                <h6 className="textPay">Total a pagar:</h6>
                                            </div>
                                            <div className="amountCheckBox col-6">
                                                <input type="radio" disabled={this.state.radioDis} name="pago" id="PagoParcial" value="pagoParcial" onChange={this.CambioRadio} checked={this.state.checkRadio === "pagoParcial"} aria-label="Radio button for following text input" className="mt-1"  /*onSelect={selectRadio}*/ />
                                                <h6 className="textPay">Otra cantidad</h6>
                                                <span className='derecha' > MXN</span>
                                            </div>
                                        </div>
                                        <div className="amountSection row mb-3">
                                            <div className="amountCheckBoxPay col-6">
                                                <h6>${this.state.saldoAnterior}</h6>
                                            </div>
                                            <div className="amountCheckBox col-6">
                                                <CurrencyInput id="inpSaldoParcial" onChange={this.ChangeCantidad} placeholder="$0.00" type="text" />
                                                {/* <input type="number" id="inpSaldoParcial" onChange={this.ChangeCantidad} className="form-control otherAmount" placeholder="$0.00" /> */}
                                                {/* <div className="dropdown">
                                                        <button className="btn payOption btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> MXN </button>
                                                    </div> */}
                                            </div>
                                        </div>
                                        <div className="payButtons">
                                            <div className="payButton">
                                            <form id="FormDom" action="https://domiciliacion.tec.mx/PostTienda/Domiciliacion" method="POST"  target={this.state.urlParamIdPort == process.env.REACT_APP_IDMIPORTAL ? '_blank' : this.state.urlParamIdPort == process.env.REACT_APP_IDMIPORTAL ?  '_self' : '_self'}>
                                                    <input type="input" hidden readOnly value={this.state.matriculaEncrp} id="DomiOutMat" name="matricula" />
                                                    <input type="input" hidden readOnly value={this.state.nombreEncr} id="DomiOutNom" name="nombre" />
                                                    <input type="input" hidden readOnly value={this.state.codigoTienda} id="DomiOutCodTi" name="codigoTienda" />
                                                    <input type="input" hidden readOnly value={this.state.cvetienda} id="DomiOutCVETi" name="cvetienda" />
                                                    <input type="input" hidden readOnly value={this.state.llaveTienda} id="DomiOutLlaveTi" name="llaveTienda" />
                                                    <input type="input" hidden readOnly value={this.state.servicio} id="DomiOutServ" name="servicio" />
                                                    <input type="input" hidden readOnly value={this.state.tipoTransaccion} id="DomiOutTipoTran" name="tipoTransaccion" />
                                                    <input type="input" hidden readOnly value={this.state.idioma} id="DomiOutIdio" name="idioma" />
                                                    <input type="input" hidden readOnly value={this.state.emailEncrp} id="DomiOutCorreo" name="email" />
                                                    <input type="input" hidden readOnly value={this.state.urlRegreso} id="DomiOuturlRegreso" name="urlRegreso" /> {/* <button type="submit">enviar</button> */}
                                                    <button id="btnDmi" type="button" onClick={this.Domiciliar} disabled={this.state.botonBloqueoDomiciliar} className="btn btnEnd btn-outline-secondary"> Domiciliar <span className={this.state.botonSpinner}></span> </button>
                                                </form>
                                                
                                            </div>
                                            <div className="payButton">
                                            <form action="https://checkoutpprd.tec.mx/PostTienda/Index"  method="POST" id="FormCheckOut" target={this.state.urlParamIdPort == process.env.REACT_APP_IDMIPORTAL ? '_blank' :this.state.urlParamIdPort == process.env.REACT_APP_IDMIPORTAL ?  '_self' : '_self'}>
                                                    <input type="input" readOnly value={this.state.matriculaEncrp} id="CheckOutMat" name="matricula" hidden />
                                                    <input type="input" readOnly value={this.state.nombreEncr} id="CheckOutNom" name="nombre" hidden />
                                                    <input type="input" readOnly value={this.state.campusEncrp} id="CheckOutCamp" name="campus" hidden />
                                                    <input type="input" readOnly value={this.state.montoInicial} id="CheckOutMontIn" name="montoInicial" hidden />
                                                    <input type="input" readOnly value={this.state.cantidad} id="CheckOutCant" name="cantidad" hidden />
                                                    <input type="input" readOnly value={this.state.codigoTienda} id="CheckOutCodTi" name="codigoTienda" hidden />
                                                    <input type="input" readOnly value={this.state.cvetienda} id="CheckOutCVETi" name="cvetienda" hidden />
                                                    <input type="input" readOnly value={this.state.llaveTienda} id="CheckOutLlaveTi" name="llaveTienda" hidden />
                                                    <input type="input" readOnly value={this.state.folioTienda} id="CheckOutFolTi" name="folioTienda" hidden />
                                                    <input type="input" readOnly value={this.state.tipoMoneda} id="CheckOutTipMoneda" name="tipoMoneda" hidden />
                                                    <input type="input" readOnly value={this.state.servicio} id="CheckOutServ" name="servicio" hidden />
                                                    <input type="input" readOnly value={this.state.tipoTransaccion} id="CheckOutTipoTra" name="tipoTransaccion" hidden />
                                                    <input type="input" readOnly value={this.state.descServicio} id="CheckOutDescServ" name="descServicio" hidden />
                                                    <input type="input" readOnly value={this.state.idioma} id="CheckOutIdio" name="idioma" hidden />
                                                    <input type="input" readOnly value={this.state.emailEncrp} id="CheckOutEmail" name="email" hidden />
                                                    <input type="input" readOnly value={this.state.urlRegreso} id="CheckOutUrlRe" name="urlRegreso" hidden />
                                                    <input type="input" readOnly value={this.state.urlAviso} id="CheckOutUrlAv" name="urlAviso" hidden />
                                                    <input type="input" readOnly value={this.state.opcional} id="CheckOutOpc" name="opcional" hidden />
                                                    <input type="input" readOnly value={this.state.q} id="CheckOutQ" name="q" hidden />
                                                    <input type="input" readOnly value={this.state.termEncrp} id="CheckOutTerm" name="term" hidden /> {/* <button type="submit">enviar</button> */}
                                                    <button id="btnCho" type="button" onClick={this.EnvioCheckOut} disabled={this.state.botonBloqueoPago} className="btn btnEnd btn-success"> Proceder al pago <span className={this.state.botonSpinner}></span> </button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </Tab>
                                <Tab eventKey={2} title="Préstamo Educativo">
                                    <div className="billSection">
                                        <div className="billRow row billRowMain">
                                            <div className="col-6 ">
                                                <p>{this.state.saldoFavorPE}</p>
                                            </div>
                                            <div className="col-6 payInfo">
                                                ${<h6>{this.state.saldoTotalPE}</h6>}
                                            </div>
                                        </div>
                                        <div className="billRow">
                                            <div className="billRow row">
                                                <div className="col-6">
                                                    <h6 className="infoDisplay md-2">Saldo por Vencer</h6>
                                                </div>
                                                <div className="col-6 payInfo">
                                                    ${<h6>{this.state.saldoVencer}</h6>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="billRow">
                                            <div className="billRow row"></div>
                                        </div>
                                        <div className="billRow">
                                            <div className="billRow row">
                                                <div className="col-6">
                                                    <h6 className="infoDisplay">Saldo a pagar</h6>
                                                </div>
                                                <div className="col-6 payInfo">
                                                    ${<h6>{this.state.cantidadPagar}</h6>}

                                                </div>
                                            </div>
                                        </div>
                                        <div className="billRow">
                                            <div className="billRow row mt-3">
                                                <div className="col-6">
                                                    <p className="infoDisplay mb-2">Saldo del mes</p>
                                                    <p>Intereses generados</p>
                                                    <p>Periodo</p>
                                                </div>
                                                <div className="col-6 payDate">
                                                    {/* <h6>{this.state.saldoMes}</h6>
                                <h6>{this.state.interesMoratorio}</h6> */}
                                                    ${this.state.saldoMes}<h6></h6>
                                                    ${this.state.interesMoratorio}<h6></h6>
                                                    {this.state.periodo}<h6></h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="paySection">
                                        <div>
                                            <div>
                                                <p>Pagar</p>
                                            </div>
                                        </div>
                                        <div className="amountSection row">
                                            <div className="amountCheckBox col-6">
                                                <input type="radio" disabled={this.state.radioDis} name="pagoPE" id="PagoCompletoPE" value="pagoCompletoPE" onChange={this.CambioRadioPE} checked={this.state.checkRadioPE === "pagoCompletoPE"} aria-label="Radio button for following text input" className="mt-1" />
                                                <h6 className="textPay">Total a pagar:</h6>
                                            </div>
                                            <div className="amountCheckBox col-6">
                                                <input type="radio" disabled={this.state.radioDis} name="pagoPE" id="PagoParcialPE" value="pagoParcialPE" onChange={this.CambioRadioPE} checked={this.state.checkRadioPE === "pagoParcialPE"} aria-label="Radio button for following text input" className="mt-1"  /*onSelect={selectRadio}*/ />
                                                <h6 className="textPay">Otra cantidad </h6>
                                                <span className='derecha' >MXN</span>
                                            </div>
                                        </div>
                                        <div className="amountSection row mb-3">
                                            <div className="amountCheckBoxPay col-6">
                                                <h6>${this.state.cantidadPagar}</h6>
                                            </div>
                                            <div className="amountCheckBox col-6">
                                                {/* <input type="number" id="inpSaldoParcialPE" onChange={this.ChangeCantidadPE} className="form-control otherAmount" placeholder="$0.00" /> */}
                                                <CurrencyInput id="inpSaldoParcialPE" onChange={this.ChangeCantidadPE} placeholder="$0.00" type="text" />
                                                {/* <div className="dropdown">
                                                    <button className="btn payOption btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> MXN </button>
                                                </div> */}
                                            </div>
                                        </div>
                                        <div className="payButtons">
                                            <div className="payButton">
                                           
                                                <form id="FormDom" action="https://domiciliacion.tec.mx/PostTienda/Domiciliacion" method="POST" target={this.state.urlParamIdPort === process.env.REACT_APP_IDMIPORTAL ? '_blank' : this.state.urlParamIdPort == process.env.REACT_APP_IDMIPORTAL ?  '_self' : '_self'}>
                                                    <input type="input" readOnly value={this.state.matriculaEncrp} id="DomiOutMat" name="matricula" hidden />
                                                    <input type="input" readOnly value={this.state.nombreEncr} id="DomiOutNom" name="nombre" hidden />
                                                    <input type="input" readOnly value={this.state.codigoTienda} id="DomiOutCodTi" name="codigoTienda" hidden />
                                                    <input type="input" readOnly value={this.state.cvetienda} id="DomiOutCVETi" name="cvetienda" hidden />
                                                    <input type="input" readOnly value={this.state.llaveTienda} id="DomiOutLlaveTi" name="llaveTienda" hidden />
                                                    <input type="input" readOnly value={this.state.servicio} id="DomiOutServ" name="servicio" hidden />
                                                    <input type="input" readOnly value={this.state.tipoTransaccion} id="DomiOutTipoTran" name="tipoTransaccion" hidden />
                                                    <input type="input" readOnly value={this.state.idioma} id="DomiOutIdio" name="idioma" hidden />
                                                    <input type="input" readOnly value={this.state.emailEncrp} id="DomiOutCorreo" name="email" hidden />
                                                    <input type="input" readOnly value={this.state.urlRegreso} id="DomiOuturlRegreso" name="urlRegreso" hidden />
                                                    <button id="btnDmi" type="button" onClick={this.DomiciliarPE} disabled={this.state.botonBloqueoDomiciliarPE} className="btn btnEnd btn-outline-secondary"> Domiciliar <span className={this.state.botonSpinnerPE}></span> </button>
                                                </form>
                                            </div>
                                            <div className="payButton">
                                            <form action="https://checkoutpprd.tec.mx/PostTienda/Index"  method="POST" id="FormCheckOut" target={this.state.urlParamIdPort === process.env.REACT_APP_IDMIPORTAL ? '_blank' : this.state.urlParamIdPort == process.env.REACT_APP_IDMIPORTAL ?  '_self' : '_self'}>
                                                    <input type="input" readOnly value={this.state.matriculaEncrp} id="CheckOutMat" name="matricula" hidden />
                                                    <input type="input" readOnly value={this.state.nombreEncr} id="CheckOutNom" name="nombre" hidden />
                                                    <input type="input" readOnly value={this.state.campusEncrp} id="CheckOutCamp" name="campus" hidden />
                                                    <input type="input" readOnly value={this.state.montoInicial} id="CheckOutMontIn" name="montoInicial" hidden />
                                                    <input type="input" readOnly value={this.state.cantidad} id="CheckOutCant" name="cantidad" hidden />
                                                    <input type="input" readOnly value={this.state.codigoTienda} id="CheckOutCodTi" name="codigoTienda" hidden />
                                                    <input type="input" readOnly value={this.state.cvetienda} id="CheckOutCVETi" name="cvetienda" hidden />
                                                    <input type="input" readOnly value={this.state.llaveTienda} id="CheckOutLlaveTi" name="llaveTienda" hidden />
                                                    <input type="input" readOnly value={this.state.folioTienda} id="CheckOutFolTi" name="folioTienda" hidden />
                                                    <input type="input" readOnly value={this.state.tipoMoneda} id="CheckOutTipMoneda" name="tipoMoneda" hidden />
                                                    <input type="input" readOnly value={this.state.servicio} id="CheckOutServ" name="servicio" hidden />
                                                    <input type="input" readOnly value={this.state.tipoTransaccion} id="CheckOutTipoTra" name="tipoTransaccion" hidden />
                                                    <input type="input" readOnly value={this.state.descServicio} id="CheckOutDescServ" name="descServicio" hidden />
                                                    <input type="input" readOnly value={this.state.idioma} id="CheckOutIdio" name="idioma" hidden />
                                                    <input type="input" readOnly value={this.state.emailEncrp} id="CheckOutEmail" name="email" hidden />
                                                    <input type="input" readOnly value={this.state.urlRegreso} id="CheckOutUrlRe" name="urlRegreso" hidden />
                                                    <input type="input" readOnly value={this.state.urlAviso} id="CheckOutUrlAv" name="urlAviso" hidden />
                                                    <input type="input" readOnly value={this.state.opcional} id="CheckOutOpc" name="opcional" hidden />
                                                    <input type="input" readOnly value={this.state.q} id="CheckOutQ" name="q" hidden />
                                                    <input type="input" readOnly value={this.state.termEncrp} id="CheckOutTerm" name="term" hidden />
                                                    <button id="btnCho" type="button" onClick={this.EnvioCheckOutPE} disabled={this.state.botonBloqueoPagoPE} className="btn btnEnd btn-success"> Proceder al pago <span className={this.state.botonSpinnerPE}></span> </button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </Tab>

                            </Tabs>
                        </div>
                        <div>
                            <center>
                                Vigencia de consulta: {this.state.fechaConsulta}

                            </center>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
